import { render } from "./Welcome.vue?vue&type=template&id=2aadd10f&scoped=true&lang=html"
import script from "./Welcome.vue?vue&type=script&lang=js"
export * from "./Welcome.vue?vue&type=script&lang=js"

import "./Welcome.vue?vue&type=style&index=0&id=2aadd10f&lang=css&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2aadd10f"]])

export default __exports__